import { FormsModule } from '@angular/forms';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { TreeModule } from 'primeng/tree';
import { SliderModule } from 'primeng/slider';
import { InputNumberModule } from 'primeng/inputnumber';
import { DatePickerModule } from 'primeng/datepicker';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FiltersUtil } from '../../pages/catalog/product-list/utils/filters-util';
import { differenceInDays, differenceInMonths, differenceInYears } from "date-fns";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-filters',
  standalone: true,
  imports: [
    FormsModule,
    CheckboxModule,
    InputTextModule,
    MultiSelectModule,
    ScrollPanelModule,
    ButtonModule,
    TreeModule,
    SliderModule,
    InputNumberModule,
    DatePickerModule,
    RadioButtonModule,
    TranslateModule
  ],
  templateUrl: './filters.component.html',
  styleUrl: './filters.component.scss',
})
export class FiltersComponent implements OnInit {
  filters = [];
  values = [];
  since;
  outlined = true;
  maxDate = new Date();
  minDate = new Date('01/01/1950');
  today = new Date();
  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private readonly changesDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.filters = this.config.data.filters;
    const appliedFilters = this.config.data.appliedFilters;
  
    this.initializeFilterValues(appliedFilters);
    this.changesDetectorRef.detectChanges();
  }
  
  private initializeFilterValues(appliedFilters): void {
    for (const filter of this.filters) {
      this.values[filter.name] = this.getDefaultFilterValue(filter);
  
      if (appliedFilters[filter.name]) {
        this.values[filter.name] = appliedFilters[filter.name];
        if (filter.type === 'dateTime') {
          this.since = this.calculateSinceValue(this.values[filter.name]);
        }
      }
    }
  }
  
  private getDefaultFilterValue(filter): any {
    if (filter.type === 'slider') {
      return [0, 100];
    }
    if (filter.type === 'dateTime') {
      return [null, null];
    }
    return null;
  }
  
  private calculateSinceValue(dateRange): string | null {
    if (!dateRange[0] || !dateRange[1]) return null;
  
    const years = differenceInYears(dateRange[1], dateRange[0]);
    if (years === 1) return 'year';
  
    const months = differenceInMonths(dateRange[1], dateRange[0]);
    if (months === 1) return 'month';
  
    const days = differenceInDays(dateRange[1], dateRange[0]);
    if (days === 7) return 'week';
    if (days === 1) return 'day';
  
    return null;
  }

  updateRange(filter) {
    this.values[filter] = [...this.values[filter]];
    this.changesDetectorRef.detectChanges();
  }

  verifyRange(filter) {
    if (this.values[filter][0] > this.values[filter][1]) {
      const temp = this.values[filter][0];
      this.values[filter][0] = this.values[filter][1];
      this.values[filter][1] = temp;
      this.changesDetectorRef.detectChanges();
    }
  }

  updateDateValues(name) {
    this.values[name] = FiltersUtil.updateDateValues(this.since);
    return this.values[name];
  }

  closeModal() {
    this.ref.close(this.values);
  }

  dateChange(name, date) {
    this.outlined = false;
    if(name === 'start') {
      this.minDate = date;
    } else {
      this.maxDate = date;
    }
  }

}
